// Test and Campaign Detail dialogs - All German
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from '../components/ui/dialog';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { Send, Loader2 } from 'lucide-react';
import DOMPurify from 'dompurify';

export function TestDialog({ open, onClose, email, setEmail, sending, onSend }) {
  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent>
        <DialogHeader><DialogTitle>Test-E-Mail</DialogTitle></DialogHeader>
        <div><Label>E-Mail</Label><Input type="email" value={email} onChange={e => setEmail(e.target.value)} placeholder="test@beispiel.ch" /></div>
        <DialogFooter><Button variant="outline" onClick={onClose}>Abbrechen</Button><Button onClick={onSend} disabled={sending}>{sending ? <Loader2 className="h-4 w-4 animate-spin" /> : <Send className="h-4 w-4 mr-1" />}Senden</Button></DialogFooter>
      </DialogContent>
    </Dialog>
  );
}

export function CampaignDetail({ open, onClose, c }) {
  if (!c) return null;
  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent className="max-w-2xl max-h-[85vh] overflow-y-auto">
        <DialogHeader><DialogTitle>Kampagnendetails</DialogTitle></DialogHeader>
        <div className="space-y-4">
          <div className="grid grid-cols-2 gap-4">
            <div><Label className="text-muted-foreground">Datum</Label><p>{new Date(c.started_at).toLocaleString('de-DE')}</p></div>
            <div><Label className="text-muted-foreground">Absender</Label><p>{c.sender_name}</p></div>
          </div>
          <div><Label className="text-muted-foreground">Betreff</Label><p className="font-medium">{c.subject}</p></div>
          <div className="grid grid-cols-3 gap-4">
            <div className="bg-muted p-3 rounded text-center"><p className="text-xl font-bold">{c.total_recipients}</p><p className="text-xs">Gesamt</p></div>
            <div className="bg-green-100 p-3 rounded text-center"><p className="text-xl font-bold text-green-600">{c.sent_count}</p><p className="text-xs">Gesendet</p></div>
            <div className="bg-red-100 p-3 rounded text-center"><p className="text-xl font-bold text-red-600">{c.failed_count}</p><p className="text-xs">Fehler</p></div>
          </div>
          <div><Label>Inhalt</Label><div className="border rounded p-3 mt-2 bg-white text-sm"><div dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(c.html_content) }} /></div></div>
        </div>
        <DialogFooter><Button onClick={onClose}>Schliessen</Button></DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
